import React,{ useRef } from "react";
// import certificate from '../../../assets/images/certificate_bg.png';
// import certificate from '../../../assets/images/certificate.jpeg';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FiDownload } from "react-icons/fi";
import { baseUrl, ROUTE_BASE_URL } from "../../../api/common";

const FMASCertificate = ({certificate, firstName, middleName,lastName, applicationName, membershipNumber, membershipDate}) => {

    const certificateRef = useRef(null);

    const handleDownloadPDF = () => {
        if (!certificateRef.current) return;
    
        // Use html2canvas to capture the invoice as an image
        html2canvas(certificateRef.current, {
          scale: 2,
          logging: false,
          useCORS: true,
        }).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
    
          // Create PDF with proper dimensions (A4)
          const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
          });
    
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
          const imgWidth = canvas.width;
          const imgHeight = canvas.height;
          const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
          const imgX = (pdfWidth - imgWidth * ratio) / 2;
          const imgY = 0;
    
          pdf.addImage(
            imgData,
            "PNG",
            imgX,
            imgY,
            imgWidth * ratio,
            imgHeight * ratio
          );
          pdf.save(
            `${firstName}-${membershipNumber}.pdf`
          );
        });
      };
  return (
    <>
      <style>
        {`
          .lino_font {
              font-family: 'Linotext', serif;
          }
          .fs_15 {
              font-size: 15px;
          }
          .certificate-container {
              width: 794px;
              height: 1123px;
              margin: auto;
              position: relative;
              text-align: center;
              padding: 9pc 7pc 8pc 6pc;
              background: white;
              background-image: url(${certificate});
              background-size: 100% 100%;
              background-position: center;
              background-repeat: no-repeat;
              display: flex;
              justify-content: center;
              align-items: center;
          }
          .certificate-header img {
              width: 100px;
              margin-bottom: 20px;
          }
          .certificate-title {
              color: red;
          }
          .certificate-content {
              margin: 15px 0;             
              font-size: 16px;
          }
          .mt-40{
            margin-top: 40px;
          }
          .mt-30{
            margin-top: 30px;
          }
          .mb-30{
            margin-bottom: 100px;
          }
          .certificate-name {
              font-weight: bold;
              font-size: 25px;
          }
          .details-section {
              display: flex;
              justify-content: space-between;
          }
          .signature-section {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 40px;
          }
          .signature-box {
              text-align: center;
          }
          .signature-box img {
              width: 120px;
          }
          .seal-logo img {
              width: 120px;
          }
        `}
      </style>
        <div className="w-full relative mb-16 download_button_div">
            <button onClick={handleDownloadPDF} className="btn btn-primary">
                <FiDownload size={18} /> Download PDF
            </button>
        </div>

      <div ref={certificateRef} className="certificate-container">
        {/* Certificate Name */}
        <h3 className="certificate-name mt-30 mb-30">
          Dr. {firstName ? firstName : ""}
              {middleName ? " " + middleName : ""}
              {lastName ? " " + lastName : ""}
        </h3>
      </div>
    </>
  );
};

export default FMASCertificate;
